import axiosInstance from './axiosInstance';

export const adminLogin = (data) => axiosInstance.post('/auth/admin/login', data);
export const requestAdminReset = (data) => axiosInstance.post('/auth/admin/request-reset', data);
export const confirmAdminReset = (data) => axiosInstance.post('/auth/admin/reset-password', data);
export const requestOtp = (data) => axiosInstance.post('/auth/candidate/request-otp', data);
export const verifyOtp = (data) => axiosInstance.post('/auth/candidate/verify-otp', data);
export const getMe = () => axiosInstance.get('/auth/me');
